module.exports = __webpack_public_path__ + "static/media/resume.47c4d39d.pdf";